import React from "react";
import "./LoaderMain.css";
import Logo from '../../../assets/logo.png'
const LoaderMain = () => {
  return (
    <div className="loader-main-container">
        <img className="logo-loader" src={Logo} alt="Logo"  style={{position : "absolute", width:80, height:80, marginBottom: 55,zIndex:0}}/>
      <svg xmlns="http://www.w3.org/2000/svg" height="200" width="200">
        <g>
          <polygon
            transform="rotate(45 100 100)"
            strokeWidth="1"
            stroke="#C3CDE6"
            fill="none"
            points="70,70 148,50 130,130 50,150"
            className="loader-main-bounce"
          ></polygon>
          <polygon
            transform="rotate(45 100 100)"
            strokeWidth="1"
            stroke="#C3CDE6"
            fill="none"
            points="70,70 148,50 130,130 50,150"
            className="loader-main-bounce2"
          ></polygon>
          <polygon
            transform="rotate(45 100 100)"
            strokeWidth="2"
            fill="#414750"
            points="70,70 150,50 130,130 50,150"
          ></polygon>
          <polygon
            strokeWidth="2"
            fill="url(#loader-main-gradient)"
            points="100,70 150,100 100,130 50,100"
          ></polygon>
          <defs>
            <linearGradient
              y2="100%"
              x2="10%"
              y1="0%"
              x1="0%"
              id="loader-main-gradient"
            >
              <stop style={{ stopColor: "#1e2026", stopOpacity: 1 }} offset="20%"></stop>
              <stop style={{ stopColor: "#414750", stopOpacity: 1 }} offset="60%"></stop>
            </linearGradient>
          </defs>
          <polygon
            transform="translate(20, 31)"
            strokeWidth="2"
            fill="rgba(57, 60, 218, 0.47)"
            points="80,50 80,75 80,99 40,75"
          ></polygon>
          <polygon
            transform="translate(20, 31)"
            strokeWidth="2"
            fill="url(#loader-main-gradient2)"
            points="40,-40 80,-40 80,99 40,75"
          ></polygon>
          <defs>
            <linearGradient
              y2="100%"
              x2="0%"
              y1="-17%"
              x1="10%"
              id="loader-main-gradient2"
            >
              <stop style={{ stopColor: "#d3a51000", stopOpacity: 1 }} offset="20%"></stop>
              <stop
                style={{ stopColor: "#B7ADEC", stopOpacity: 1 }}
                offset="100%"
                className="loader-main-animated-stop"
              ></stop>
            </linearGradient>
          </defs>
          <polygon
            transform="rotate(180 100 100) translate(20, 20)"
            strokeWidth="2"
            fill="rgba(37, 37, 223, 0.68)"
            points="80,50 80,75 80,99 40,75"
          ></polygon>
          <polygon
            transform="rotate(0 100 100) translate(60, 20)"
            strokeWidth="2"
            fill="url(#loader-main-gradient3)"
            points="40,-40 80,-40 80,85 40,110.2"
          ></polygon>
          <defs>
            <linearGradient
              y2="100%"
              x2="10%"
              y1="0%"
              x1="0%"
              id="loader-main-gradient3"
            >
              <stop style={{ stopColor: "#d3a51000", stopOpacity: 1 }} offset="20%"></stop>
              <stop
                style={{ stopColor: "#B7ADEC", stopOpacity: 1 }}
                offset="100%"
                className="loader-main-animated-stop"
              ></stop>
            </linearGradient>
          </defs>
          <polygon
            transform="rotate(45 100 100) translate(80, 95)"
            strokeWidth="2"
            fill="#fff"
            points="5,0 5,5 0,5 0,0"
            className="loader-main-particles"
          ></polygon>
          <polygon
            transform="rotate(45 100 100) translate(80, 55)"
            strokeWidth="2"
            fill="#fff"
            points="6,0 6,6 0,6 0,0"
            className="loader-main-particles"
          ></polygon>
          <polygon
            transform="rotate(45 100 100) translate(70, 80)"
            strokeWidth="2"
            fill="#fff"
            points="2,0 2,2 0,2 0,0"
            className="loader-main-particles"
          ></polygon>
          <polygon
            strokeWidth="2"
            fill="#292d34"
            points="29.5,99.8 100,142 100,172 29.5,130"
          ></polygon>
          <polygon
            transform="translate(50, 92)"
            strokeWidth="2"
            fill="#1f2127"
            points="50,50 120.5,8 120.5,35 50,80"
          ></polygon>
        </g>
      </svg>
    </div>
  );
};

export default LoaderMain;
